export default "__VITE_ASSET__DsbhwIyL__"